module.exports = __webpack_public_path__ + "static/media/Cuadricula_5-gris.095962e2.svg";